<template>
    <div class="sustainable-component competence-emplyee-category-competence">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-admin-competence-category</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    {{categoryname}}
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <table class="table table-light table-hover table-striped competence-list-table"
                           cellspacing="0"
                           cellpadding="8"
                           border="0">
                        <thead>
                            <tr>
                                <th class="competence-list-name" style="font-weight:normal">Utbildning</th>
                                <th class="competence-list-action"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in competencelist" :key="index">
                                <td class="competence-list-name">
                                    <span>{{ item.Name }}</span>
                                </td>
                                <td class="competence-list-action py-0">
                                    <v-checkbox v-bind:disabled="disabled"
                                                density="compact"
                                                v-model="item.IsActiveForEmployee"
                                                hide-details></v-checkbox>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import CommonSpinner from '../../common/common-spinner.vue'
    
    export default {

        name: 'competence-emplyee-category-competence',
        emits: ['updated'],
        props: {
            model: Object,
            competencecategoryid: Number,
            categoryname: String,
            competencelist: Array,
            employeeid: Number,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {


        },
        mounted() {
            this.internalModel = this.model;
        },
        setup() {
            return {  }
        }
    }
</script>

<style scoped>
    .competence-list-table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
    }

    .competence-list-name {
        width: auto;
        min-width: 0;
        word-break: break-word;
        overflow-wrap: anywhere;
        vertical-align: middle;
    }

    .competence-list-action {
        width: 3rem;
        white-space: nowrap;
        text-align: right;
        vertical-align: middle;
    }
</style>
